import { useMemo, useRef, useState } from 'react';
import { ReactSimpleComponentProps, UnityDetail } from '@/custom-types';
import { AddUnityFormModalContext, AddUnityFormModalContextProps } from './AddUnityFormModalContext';

export const AddUnityFormModalContextProvider = ({ children }: ReactSimpleComponentProps) => {
  const unityDataRef = useRef<UnityDetail | null>(null)
  const [isOpen, setOpen] = useState(false)

  const actions = useMemo<Omit<AddUnityFormModalContextProps, 'unityData' | 'isOpen'>>(() => ({
    closeModal: () => {
      setOpen(false)
      unityDataRef.current = null
    },

    openModal: (unityData?: UnityDetail) => {
      setOpen(true)

      if (unityData) unityDataRef.current = unityData
    },
  }), [])

  return (
    <AddUnityFormModalContext.Provider value={{ ...actions, isOpen, unityData: unityDataRef.current}}>
      {children}
    </AddUnityFormModalContext.Provider>
  )
}